import CircularProgress from '@material-ui/core/CircularProgress'

import './styles.less'

const CircularProgressBar = ({ size, thickness }) => {
  return (
    <div className='circular-progress-bar'>
      <CircularProgress size={size || 40} thickness={thickness || 5} />
    </div>
  )
}

export default CircularProgressBar
